module.exports = __webpack_public_path__ + "static/media/header_logo.ff17242f.svg";